import { Injectable } from "@angular/core";
import { ApiResponse } from "../models/common.model";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BehaviorSubject, Subject } from "rxjs";
import { LocalServiceService } from "./local-service.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  public countOfExperiences: number = 0;
  public baseUrl = environment.baseUrlAdmin;

  // Common Data For reuse purpose
  public tagList: Array<any> = [];
  public regionList: Array<any> = [];
  public regionObserver: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]);
  public subRegionLists: Array<any> = [];
  public subRegionAllRegionId: number = 0;
  public subRegionObserver: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]);
  public userTagList: Array<any> = [];
  public subRegionListBaseProduct: Array<any> = [];
  public subRegionListBaseProductObserver: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]);
  public categoryList: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]); //Category List with Sub category
  public subCategoryList = [];
  public clientIp: string = '';
  public popupImagesList: Array<any> = [];
  public popupImagesObserver: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]);
  public mapCustomization: any = {};
  public mapCustomizationObserver: BehaviorSubject<any> = new BehaviorSubject<any>({});
  
  // Customization properties
  public customization: any = {};
  public customizationObserver: BehaviorSubject<any> = new BehaviorSubject<any>({});
  
  public doesProductMatch(product, searchText): boolean {
    return [product?.name, product?.companyName, product?.description].some(str => str?.toLowerCase()?.includes(searchText))
  }

  public getProductCountsKey(subregionId, { subCatId = '', typeId = '' }) {
    if (subCatId) {
      return `${subregionId}x${subCatId}`;
    } else if (typeId) {
      return `${subregionId}xT${typeId}`;
    }
  }

  // Common Data For reuse purpose
  public isSameFile(fileA, fileB) {
    return (
      fileA.name === fileB.name &&
      fileA.size === fileB.size &&
      fileA.type === fileB.type &&
      fileA.lastModified === fileB.lastModified
    );
  }

  public timeAgo(dateInput): string {
    if (!dateInput) return 'Invalid date';

    let date: Date;

    // Handle Unix timestamp (seconds vs milliseconds)
    if (typeof dateInput === 'number') {
      date = new Date(dateInput < 1e12 ? dateInput * 1000 : dateInput);
    } else {
      date = new Date(dateInput);
    }

    if (isNaN(date.getTime())) return 'Invalid date';

    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 0) return 'In the future';

    const intervals: { [key: string]: number } = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
    };

    for (const [unit, secondsInUnit] of Object.entries(intervals)) {
      const interval = Math.floor(seconds / secondsInUnit);
      if (interval >= 1) {
        return `${interval} ${unit}${interval > 1 ? 's' : ''} ago`;
      }
    }

    return 'Just now';
  }

  public getProductInformationScore(productData) {
    if(productData?.isAd || productData?.isTypeShop){
      return 10;
    }

    const getBadgeCount = (productData) => {
      if (!productData) {
        return 0;
      }

      let sellerInfo = productData['seller_info'];

      if (!sellerInfo) {
        return 0
      }

      let rv = 0
      if (productData?.isPopuplarInSubRegion) {
        rv++;
      }

      const fields = ['googleReviewRating', 'fbReviewRating', 'carousellReviewRating',
        'superDealRating', 'bestPriceRating', 'highQualityRating']
      if (typeof sellerInfo == 'string') {
        sellerInfo = JSON.parse(sellerInfo)
      }

      for (const field of fields) {
        if (sellerInfo[field]) {
          rv++;
        }
      }
      return rv;
    }
    const infos = [
      productData?.companyName,
      // productData?.name,
      productData?.shopPageEnabled,
      productData?.xpCount,
      productData?.bizCompanyEmployeesCount,
      productData?.foodFavoritesCount,
      productData?.productMoreServicesCount,
      productData?.productVerficationsList?.length || productData?.verifiedTag,
      productData?.memberProductReviewCount,
      getBadgeCount(productData),
      productData?.additionalTag
    ]
    let rv = 0;
    for (const info of infos) {
      if (info) {
        rv++;
      }
    }
    return rv

  }

  // public readonly catPriority = [
  //   'Food & Beverage',
  //   'Local Delights',
  //   'Education',
  //   'Automobile & Transport',
  //   'Beauty & Grooming',
  //   'Cleaning',
  //   'Maids, Nannies & Helpers',
  //   'Home Improvement',
  //   'Health & Wellness',
  //   'Electronics',
  //   'Games and Hobbies',
  //   'Fitness',
  //   'Events',
  //   'Pets',

  //   'Others',
  // ];


  public getCategoryOrTypeId(selectedMapCategory, currentSelectedTypes) {
    let selectedCategoryId = selectedMapCategory?.id;

    const isSelectSubCat = !!selectedMapCategory?.categorieChildId;

    if (isSelectSubCat) {
      selectedCategoryId = selectedMapCategory?.categorieChildId;
    }

    const id = currentSelectedTypes?.length
      ? currentSelectedTypes[0]?.id
      : selectedCategoryId;
    const isType = !!currentSelectedTypes?.length;
    return { id, isType };
  }

  public updateUrlWithQueryParam(key: string, value: string | null): void {

    const url = new URL(window.location.href);

    if (value === null) {
      // Remove the query parameter
      url.searchParams.delete(key);
    } else {
      // Add or update the query parameter
      url.searchParams.set(key, value);
    }

    // Build the new URL preserving existing query params
    const newQueryString = url.searchParams.toString();
    const basePath = window.location.pathname;
    const newUrl = newQueryString ? basePath + '?' + newQueryString : basePath;
    this.location.replaceState(newUrl);
  }

  async convertWithWebCodecs(file) {
    const bitmap = await createImageBitmap(file);

    const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0);

    const blob = await canvas.convertToBlob({ type: "image/webp", quality: 0.8 });
    return new File([blob], file.name.replace(/\.\w+$/, ".webp"), { type: "image/webp" });
  }


  public setCookie(name: string, value: string, days = 7): void {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
  }

  public getCookie(name: string): string | null {

    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  }


  public changeRewardKeyName(key: string) {
    switch (key) {
      case 'REPORTS_REWARD': {
        return 'Error/Bug Report ';
      }
      case 'GLOW_ANSER': {
        return 'Answered A Glowing Survey'

      }
      case 'REVIEW_REWARD': {
        return 'Listing Updated'

      }
      case 'SUGGESTIONS_REWARD': {
        return 'Approved Suggestion';

      }
      case 'PRODUCT_POST_REWARD': {
        return 'Product Post'
      }
      case 'XP_POST_REWARD': {
        return 'Shared An Experience'
      }
      // case 'ASK_POST_REWARD':{

      // }
      // case 'MOMENTS_REWARD':{
      //   return "Posting A Moment"

      // }
    }
    return key.toLocaleLowerCase().split('_').join(' ')
  }

  public goBack() {
    const navCount = sessionStorage.getItem('navigationCount');
    if (navCount && Number(navCount) > 1) {
      console.log('going back', navCount);
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }

  }
  public linesInElement(element: Element) {
    const style = window.getComputedStyle(element);
    const lineHeight = parseFloat(style.lineHeight);
    const height = element.clientHeight;

    return Math.floor(height / lineHeight);
  };
  public convertImageToURL(fileEvent, index = 0,): Promise<[string, File]> {
    //console.log('called with', {arguments})
    return new Promise((res, rej) => {
      const file = fileEvent.target.files[index]
      const fileReader = new FileReader()
      fileReader.onload = () => res([fileReader.result as string, file]);
      fileReader.onerror = (e) => rej(e);
      fileReader.readAsDataURL(file)

    })

  }
  public sanitizeHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  constructor(private http: HttpClient, private local: LocalServiceService,
    private location: Location, private router: Router, private sanitizer: DomSanitizer) {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.getCommonRequireDataForLogInUser(true);
      }
    });
    this.getCommonRequireData();
  }

  public handleError(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/shop/default.png";
  }

  public handleBannerError(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/new/new-banner.webp";
  }

  public handleErrorUpload(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/uploadd2.png";
  }
  public handleErrorAvatar(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/w.jpeg";
  }

  public removeDuplicateAndCombineByProp(input: Array<any>, propName): Array<any> {
    let output: any = {};
    for (let i of input) {
      let filterItem = input?.filter((j) => j?.[propName] == i?.[propName]);
      if (filterItem.length > 1 && !output[i?.[propName]]) {
        i.id = filterItem?.map((i) => i.id);
        output[i[propName]] = i;
      } else if (!output[i?.[propName]]) {
        output[i?.[propName]] = filterItem;
      }
    }

    //@ts-ignore
    return Object.values(output)?.flat();
  }

  public uniqueById(arr) {
    if (arr && arr.length > 0) {
      return [...new Set(arr.map((item) => item.id))];
    } else {
      return [];
    }
  }

  public getCommonRequireData(Login: boolean = false) {
    this.http.get(`${this.baseUrl}getAllMemberSurveyInterest`).subscribe((resp: ApiResponse) => {
      this.tagList = resp.body;
    });

    this.http.get(`${this.baseUrl}getMemberShopSubRegion`).subscribe((resp: ApiResponse) => {
      this.subRegionObserver.next(structuredClone(resp.body));
      this.subRegionLists = resp.body.map((i: any) => {
        if (i.name.toLowerCase() == 'all') {
          this.subRegionAllRegionId = i?.subRegionId;
        }
        try {
          i["postalCode"] = Array.isArray(i["postalCode"]) ? i["postalCode"] : JSON.parse(i["postalCode"]) || [];
        } catch (e) {
          i["postalCode"] = [];
        }
        return i;
      });
      this.deepFreeze(this.subRegionLists);
    });

    this.http.get(`${this.baseUrl}getMemberShopSubRegionBaseOnProducts`).subscribe((resp: ApiResponse) => {
      this.subRegionListBaseProduct = resp.body;
      this.subRegionListBaseProductObserver.next(resp.body)
    });

    this.http.get(`${this.baseUrl}getMemberShopRegion`).subscribe((resp: ApiResponse) => {
      this.regionList = resp.body;
      this.regionObserver.next(resp.body);
    });

    this.http.get(`${this.baseUrl}getAllCategorieRelationship`).subscribe((resp: any) => {
      this.categoryList.next(resp.body);
      for (let i of resp.body) {
        this.subCategoryList = [...i.subCategory, ...this.subCategoryList];
      }
    });

    fetch('https://api.ipify.org?format=json')
      .then(async (response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        const resp = await response.json();
        this.clientIp = resp.ip;
      })
      .catch((err) => {
        console.error('Failed to fetch client IP address:', err?.message || err);
        this.clientIp = null;
      });


  }
  public refreshCategoryData() {
    this.http.get(`${this.baseUrl}getAllCategorieRelationship?t=${new Date().getTime()}`).subscribe((resp: any) => {
      this.categoryList.next(resp.body);
      this.subCategoryList = []
      for (let i of resp.body) {
        this.subCategoryList = [...i.subCategory, ...this.subCategoryList];
      }
    });

  }

  public getCommonRequireDataForLogInUser(Login: boolean = false) {
    if (Login) {
      this.getTagList();
    }
  }

  public getCategoryName(id) {
    if (this.subCategoryList && id) {
      return this.subCategoryList.find((i: any) => i.categorieChildId == id)?.categoryName || "";
    }
  }

  public getSubregionName(id) {
    if (this.subRegionLists && id) {
      return this.subRegionLists.find((i: any) => i.subRegionId == id)?.name || "";
    }
  }

  public getSubregionId(name) {
    if (this.subRegionLists && name) {
      name = name.includes("|") ? name.split("|")[1] : name;
      return this.subRegionLists.find((i: any) => i.name.toLowerCase() == name.toLowerCase())?.subRegionId || "";
    }
  }

  public getTagList() {
    this.http.get(`${this.baseUrl}getSurveyResponses`).subscribe((resp: ApiResponse) => {
      let tags = [];
      let ignoreTag = "";
      for (let i of resp.body) {
        ignoreTag = i.ignoreTag;
        if (i?.question && i?.question["interest_name"] == "interest") {
          tags = [...tags, ...i?.selected_option];
        } else if (i?.question && i?.question?.answer_option == i?.selected_option?.selected) {
          tags = [...tags, i?.question?.interest_name];
        }
      }
      this.userTagList = tags.filter((i: any) => !ignoreTag?.includes(i));
    });
  }

  public getSubRegionBaseOnPostalCode(postalCode): any | null {
    if (postalCode && postalCode.length >= 2) {
      return this.subRegionLists.filter((subregion) => subregion.postalCode.includes(postalCode.slice(0, 2)))[0] || null;
    } else {
      return null;
    }
  }

  public deepFreeze(obj) {
    Object.freeze(obj);
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        this.deepFreeze(obj[key]);
      }
    });
  }

  public setTheme(theme: string) {
    return;
    localStorage.setItem("selectedTheme", theme);
    document.documentElement.className = '';
    this.local.themeSubject.next(theme)
    if (theme) {
      this.setCookie('selectedTheme', theme)
      document.documentElement.classList.add(theme);
    }
  }


  public clickButton(id: string) {
    const button = document.getElementById(id);
    if (button) {
      button.click();
    } else {
      console.error('button not found!')
    }
  }

  public correctSite(site: string) {
    if (site == 'null') {
      return ''
    }
    if (site?.trim()) {
      if (site?.startsWith('https') || site?.startsWith('http')) {
        return site
      }
      if (site?.startsWith('www')) {
        return 'https://' + site
      }
      return 'https://www.' + site

    }
    return ""

  }

  public getPopupImages(filter?: string) {
    const params: any = {};
    if (filter) {
      params.filter = filter;
    }

    this.http.get(`${this.baseUrl}community/pop-up-images/get`, { params }).subscribe((resp: ApiResponse) => {
      this.popupImagesList = resp.body || [];
      this.popupImagesObserver.next(this.popupImagesList);
    });
  }

  public getPopupImageByFilterAndType(filter: string, type: string) {
    // console.log('filter', filter, 'type', type);
    return this.popupImagesList.find((img: any) => img.filter === filter && img.type === type);
  }

  public getMapCustomization(filter?: string) {
    const params: any = {};
    if (filter) {
      params.filter = filter;
    }
    this.http.get(`${this.baseUrl}community/map-customization/get`, { params }).subscribe((resp: ApiResponse) => {

      this.mapCustomization = resp.body || {};
      this.mapCustomizationObserver.next(this.mapCustomization);
    });
  }

  public saveMapCustomization(payload: {
    filter: string;
    mapSideColor: string;
    mapHeaderColor: string;
    popupLeaderColor: string;
    faqQuestionFieldColor: string;
  }) {
    return this.http.post(`${this.baseUrl}community/map-customization/add`, payload);
  }

  // Customization methods
  public getCustomization() {
    this.http.get(`${this.baseUrl}community/get-customization`).subscribe((resp: ApiResponse) => {
      this.customization = resp.body || {};
      this.customizationObserver.next(this.customization);
    });
  }

  public saveCustomization(payload: any) {
    return this.http.post(`${this.baseUrl}community/add-customization`, payload);
  }
}
